/**
 * Build a page title promise based on a ui.router state object.
 * Custom installations can override by redeclaring the service TmrPageTitle.
 *
 * @type {ngService}
 */
export class TmrPageTitle {
  static ngType = 'service'

  constructor($translate, tmrAppName) {
    'ngInject'
    return state => {
      if (state !== undefined) {
        if (state.url) {
          return $translate(state.label)
            .then(translated => `${translated} - ${tmrAppName}`)
            .catch(err => {
              // Missing translation is not an error.
              if (err != state.label) throw err
            })
        }
        return Promise.resolve(tmrAppName)
      }
      return Promise.resolve('')
    }
  }
}

/**
 * PageTitle Run phase: Set variable on $rootScope
 *
 * @type {ngRun}
 */
function tmrPageTitleRun($rootScope, $transitions, TmrPageTitle) {
  'ngInject'
  $transitions.onSuccess({}, transition =>
    TmrPageTitle(transition.targetState().state()).then(
      pageTitle => ($rootScope.pageTitle = pageTitle)
    )
  )
}

export { tmrPageTitleRun as run }
